import React, {useEffect, useState} from "react";
import CardStats from "../Cards/CardStats";
import {getDataHeader} from "../../api/auth.service";

// components
export default function HeaderStats() {

    const [field, setField] = useState({
        asociados: 0,
        clientes: 0,
        contratos: 0,
        facturas: 0
    });

    const getDataHead = async () => {
        const response = await getDataHeader();
        return await response.data;
    }

    const getHeadPromise = () => {
        getDataHead().then(r => {
            if (r.estado !== 200) {
                return;
            }

            setField({...field, asociados: r.data.asociados, clientes: r.data.clientes, contratos:r.data.contratos, facturas: r.data.facturas })
        })
    }



    useEffect(() => {
        getHeadPromise();
    }, []);


    return (
        <>
            {/* Header */}
            <div className="relative primary-color md:pt-32 pb-28 pt-12">
                <div className="px-4 md:px-10 mx-auto w-full">
                    <div>
                        {/* Card stats */}
                        <div className="sm-hidden flex flex-wrap justify-evenly ">
                            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                                <CardStats
                                    link="/afiliados"
                                    statSubtitle="AFILIADOS"
                                    statTitle={field.asociados}
                                    statIconName="fa fa-user-md"
                                    statIconColor="bg-red-500"
                                />
                            </div>
                            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                                <CardStats
                                    link="/clientes"
                                    statSubtitle="CLIENTES"
                                    statTitle={field.clientes}
                                    statIconName="fa fa-hospital"
                                    statIconColor="bg-orange-500"
                                />
                            </div>
                            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                                <CardStats
                                    link="/contratos"
                                    statSubtitle="CONTRATOS"
                                    statTitle={field.contratos}
                                    statIconName="fa fa-book"
                                    statIconColor="bg-pink-500"
                                />
                            </div>
                            {<div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                                <CardStats
                                    link="/facturas"
                                    statSubtitle="FACTURAS"
                                    statTitle={field.facturas}
                                    statIconName="fa fa-file-text"
                                    statIconColor="bg-lightBlue-500"
                                />
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
